import { di } from 'react-magnetic-di';
import { useGetJiraFieldMaxChars } from '@atlassian/help-center-virtual-agent/src/controllers/get-jira-field-max-chars';
import { useProvider } from '@atlassian/unified-help-common/src/store/routing';
import { ConversationProvider } from '@atlassian/unified-help-common/src/types';
import { MAX_CHARS } from '../../../common/constants';

export const useGetMaxChars = () => {
	di(useProvider, useGetJiraFieldMaxChars);
	const provider = useProvider();
	const { getJiraFieldMaxChars } = useGetJiraFieldMaxChars();

	const getMaxChars = () => {
		if (provider === ConversationProvider.VIRTUAL_AGENT) {
			const maxJiraFieldChars = getJiraFieldMaxChars();
			if (maxJiraFieldChars) {
				return maxJiraFieldChars;
			}
		}

		return MAX_CHARS;
	};

	return { getMaxChars };
};
